﻿import { opaccFilterCriterias } from './opacc.class.filter-criterias.factory.js';

export class DatePickerFilter {
  constructor(item,wrapper) {
    this.wrapperItem = wrapper;
    this.filterItem = item;
    this.dateRangeFilter = undefined;
    this.datePickerValues = undefined;
    this.datePickerElem = undefined;

    this.defaultDate = [];
    this.itemId = undefined;
    
    if (this.filterItem) {
      this.itemId = `#${this.filterItem.getAttribute('id')}`;
      this.datePickerElem = this.filterItem.querySelector(`${this.itemId}-date`);

      this.datePickerValues = [
        this.filterItem.querySelector(`${this.itemId}-from`),
        this.filterItem.querySelector(`${this.itemId}-to`)
      ];

      this.datePickerValues.forEach(item => {
        this.defaultDate.push(item.value);
      });

      let dateRangePickerConfig = {
        mode: 'range',
        dateFormat: 'd.m.Y',
        locale: 'de',
        inline: true,
        appendTo: this.datePickerElem.parentNode,
        defaultDate: null
      };

      // prüfen ob Attribut schon selektiert wurde um den Kalender die Selektierten Werte als Default zu übergeben
      if (this.datePickerElem.dataset.opHasSelectedItems) {
        let hasSelectedItems = (this.datePickerElem.dataset.opHasSelectedItems.toLowerCase() === 'true');
        if (hasSelectedItems) {
          dateRangePickerConfig.defaultDate = this.defaultDate;
        }
      }
      
      this.createDatePicker(dateRangePickerConfig);  
    }
  }
  
  createDatePicker(config) {
    this.dateRangeFilter = window.daterangepicker(this.filterItem, config);
    this.updateDatePicker();
  }
  
  updateDatePicker() {
    this.dateRangeFilter.config.onChange.push( (selectedDates, dateStr, instance) => {
      this.datePickerElem.value = dateStr;
      if (selectedDates.length == 2) {
        this.extractValues(selectedDates);       
      }
    });
  }
  
  extractValues(inputDates) {
    let dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    this.datePickerValues.forEach((item, index) => {
      item.value = inputDates[index].toLocaleDateString('de', dateOptions);
    });

    let formattedDates = [];
    inputDates.forEach(item => {
      formattedDates.push(item.toLocaleDateString('de', dateOptions));
    });

    let valueConcat = `[${formattedDates.join('|')}]`;
    opaccFilterCriterias.change(this.datePickerElem.dataset.opFilterattr, valueConcat);
  }
}